import { useCallback } from 'react'

import {
  UpdateOrganizationProps,
  useUpdateOrganization,
  useUserOrganization,
} from '@modules-deprecated/app/organization'

import { OrganizationInfoForm } from '../utils/formData'

export const useUpdateOrganizationInfoSettings = () => {
  const { organization } = useUserOrganization()
  const { updateAsync, isProcessing, ...rest } = useUpdateOrganization()

  const updateOrganizationInfoSettings = useCallback(
    ({ autoCompletedFields: _, ...values }: OrganizationInfoForm) => {
      if (!organization?.id) {
        return
      }

      const updateOrganizationPayload: UpdateOrganizationProps = {
        organizationId: organization.id,
        payload: values,
      }

      return updateAsync(updateOrganizationPayload)
    },
    [organization?.id, updateAsync],
  )

  return { isProcessing, ...rest, update: updateOrganizationInfoSettings }
}
